import { render, staticRenderFns } from "./ContestWinnersPlaces.vue?vue&type=template&id=76e3d1b0"
import script from "./ContestWinnersPlaces.vue?vue&type=script&lang=ts"
export * from "./ContestWinnersPlaces.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports